import type { App } from 'vue';
import { createHead } from '@unhead/vue/client';

/**
 * 设置unhead用于SEO元数据管理
 * @param app - Vue应用实例
 */
export function setupHead(app: App) {
  const head = createHead();
  app.use(head);
  console.log('[Plugin] Head initialized for SEO');
} 